<template>
  <div class="month-box">
    <RadioGroup @on-change="getValue" size="small" style="width: 100%" v-model="type">
      <!-- 每月 -->
      <div class="box-bottom">
        <Radio border label="1" size="small">每月</Radio>
      </div>
      <!-- 周期 -->
      <div class="cycle box-bottom">
        <Radio border label="2" size="small">周期</Radio>
        <template v-if="type=='2'">
          <span style="margin-right:0.5rem;">从</span>
          <InputNumber
            :max="11"
            :min="1"
            @on-change="getChangeMonth"
            size="small"
            style="width: 4rem;"
            v-model="cycle.start"
          ></InputNumber>
          <span style="margin:0 0.5rem;">至</span>
          <InputNumber
            :max="12"
            :min="parseInt(cycle.start + 1)"
            @on-change="getChangeMonth"
            size="small"
            style="width: 4rem;"
            v-model="cycle.end"
          ></InputNumber>
          <span style="margin-left:0.5rem;">月</span>
        </template>
      </div>
      <!-- 循环 -->
      <div class="cycle box-bottom">
        <Radio border label="3" size="small">循环</Radio>
        <template v-if="type=='3'">
          <span style="margin-right:0.5rem;">从</span>
          <InputNumber
            :max="12"
            :min="1"
            @on-change="getLoopMonth"
            size="small"
            style="width: 4rem;"
            v-model="loop.start"
          ></InputNumber>
          <span style="margin:0 0.5rem;">月开始，每</span>
          <InputNumber
            :max="12"
            :min="1"
            @on-change="getLoopMonth"
            size="small"
            style="width: 4rem;"
            v-model="loop.end"
          ></InputNumber>
          <span style="margin-left:0.5rem;">月执行一次</span>
        </template>
      </div>
      <!-- 指定 -->
      <div class="box-bottom">
        <Radio border label="4" size="small">指定</Radio>
        <Select
          @on-change="getAppointMonth"
          multiple
          placeholder="请选择月份"
          size="small"
          style="width: auto"
          transfer
          v-if="type=='4'"
          v-model="appoint"
        >
          <Option :key="j" :label="j+'月'" :value="j" v-for="j in 12"></Option>
        </Select>
      </div>
    </RadioGroup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      type: "1", // 类型
      // 周期
      cycle: {
        start: 1,
        end: 2
      },
      // 循环
      loop: {
        start: 1,
        end: 1
      },
      // 指定月份
      appoint: [],
      // 月份结果
      result: ""
    }
  },
  methods: {
    // 当前选择项
    getValue (value) {
      // 清空指定月份的选择项
      this.appoint = []
      if (value == "-1") {
        // 不指定 月份
        this.result = "?"
      } else if (value == "1") {
        // 指定每月
        this.result = "*"
      } else if (value == "2") {
        // 指定月份周期
        this.result = this.cycle.start + "-" + this.cycle.end
      } else if (value == "3") {
        // 指定循环周期
        this.result = this.loop.start + "/" + this.loop.end
      } else {
        this.appoint = [1]
        this.result = this.appoint.join(",")
      }
      console.log("月result", this.result)
      this.$emit("month", this.result)
    },
    // 选择月份周期
    getChangeMonth () {
      this.type = "2"
      this.result = this.cycle.start + "-" + this.cycle.end
      console.log("月result", this.result)
      this.$emit("month", this.result)
      // 清空指定状态
      this.appoint = []
    },
    // 选择月份循环
    getLoopMonth () {
      this.type = "3"
      this.result = this.loop.start + "/" + this.loop.end
      console.log("月result", this.result)
      this.$emit("month", this.result)
      // 清空指定状态
      this.appoint = []
    },
    // 选择指定月份
    getAppointMonth () {
      this.type = "4"
      this.result = this.appoint
        .sort((a, b) => {
          return a - b
        })
        .join(",")
      console.log("月result", this.result)
      this.$emit("month", this.result)
    }
  }
};
</script>
